import React, { Component } from 'react'
import { Row, Col, Button, FormGroup, Label, Input } from 'reactstrap'
import Dropzone from 'react-dropzone'
import { FileIcon } from 'react-file-icon'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import filesize from 'filesize'
import TruncateString from 'react-truncate-string'
import AsyncSelect from '../Input/AsyncSelect'
import oikosApi from '../../../services/oikos'

export default class AddFiles extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: props.files || [],
    }
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.state.files?.length > 0) {
      this.state.files.forEach(file => URL.revokeObjectURL(file.props.preview))
    }
    return null
  }

  componentDidUpdate(prevProps) {
    if (prevProps.files !== this.props.files) {
      this.setState({ files: this.props.files });
    }
  }

  handleOnDropFiles = (newAcceptedFiles) => {
    const { files } = this.state
    const { multiple, onFilesChange } = this.props

    const acceptedFormatted = newAcceptedFiles?.map(file => {
      const icon = this.formatFileIcon(file.type)
      const extension = this.extractFileExtension(file.path)
      const name = (file.path).replace(/\.[^/.]+$/, '')

      return ({
        data: file,
        props: {
          id: uuidv4(),
          preview: URL.createObjectURL(file),
          modified: moment().format('DD/MM/YYYY HH:mm'),
          icon,
          extension,
          name,
          documentType: null,
          description: null,
        },
      })
    })

    const updatedFiles = multiple ? files.concat(acceptedFormatted) : acceptedFormatted;
    this.setState({ files: multiple ? files.concat(acceptedFormatted) : acceptedFormatted })
    onFilesChange(updatedFiles); // Notify parent
  }

  getFiles = () => {
    return this.state.files;
  }

  formatFileIcon = type => {
    switch (type) {
      case 'application/pdf': return {
        color: '#ffcfcc',
        labelColor: '#FF2116',
        type: 'acrobat',
      }
      case 'image/png':
      case 'image/jpeg':
      case 'image/gif':
        return {
          color: '#ffe6cc',
          labelColor: '#ff9933',
          type: 'image',
        }
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return {
        color: '#d7f4e4',
        labelColor: '#207245',
        type: 'spreadsheet',
      }
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return {
        color: '#d7e3f4',
        labelColor: '#2a5699',
        type: 'document',
      }
      default: return {}
    }
  }

  extractFileExtension = path => {
    const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi

    return path.match(fileExtensionPattern)[0].substring(1)
  }

  handleDeleteFile = id => {
    const { onFilesChange } = this.props
    const { files } = this.state

    const filtered = files.filter(file => file.props.id !== id)

    this.setState({ files: filtered })
    if (onFilesChange) onFilesChange(filtered)
  }

  render() {
    const { files } = this.state
    const { readOnly } = this.props

    if (readOnly) {
      if (!files?.length) return <span className="text-muted">Nenhum anexo.</span>

      return (
        <>
          {files.map((file, index) => {
            const arquivoCaminho = file.props.arquivo_caminho || file.data.path
            const displayName = file.props.description || file.props.name || arquivoCaminho
            const fileUrl = arquivoCaminho ? `https://oikos.ecoss.is/oikos/${arquivoCaminho}` : null

            return (
              <div key={file.props.id}>
                <Row className="d-flex no-gutters align-items-center">
                  <a
                    href={fileUrl || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', cursor: fileUrl ? 'pointer' : 'default' }}
                    onClick={e => { if (!fileUrl) e.preventDefault() }}
                  >
                    <div className="mr-3" style={{ width: 36, height: 43 }}>
                      <FileIcon
                        radius={4}
                        extension={file.props.extension}
                        type={file.props.icon?.type}
                        color={file.props.icon?.color}
                        labelColor={file.props.icon?.labelColor}
                      />
                    </div>
                    <h6 className="mb-0">
                      <TruncateString text={displayName} />
                    </h6>
                  </a>
                </Row>
                {index < files.length - 1 && <Row><Col><hr /></Col></Row>}
              </div>
            )
          })}
        </>
      )
    }

    return (
      <>
        {files?.length > 0 && (
          <>
            {files.map((file) => (
              <div key={file.props.id}>
                <Row className="d-flex no-gutters align-items-center justify-content-between">
                  <div className="mr-3" style={{ width: 36, height: 43 }}>
                    <FileIcon
                      radius={4}
                      extension={file.props.extension}
                      type={file.props.icon.type}
                      color={file.props.icon.color}
                      labelColor={file.props.icon.labelColor}
                    />
                  </div>

                  <div className="d-flex flex-column flex-grow-1 mr-3" style={{ width: 1 }}>
                    <h6>
                      <TruncateString
                        text={file.data.path}
                      />
                    </h6>

                    <span>
                      {filesize(file.data.size, { locale: 'pt-BR', round: 0 })}
                    </span>

                    <Row className="mt-3">
                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo de documento
                          </Label>

                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            isSearchable={false}
                            isClearable={false}
                            isMulti={false}
                            getOptionValue={option => option.tpDocumento_id}
                            getOptionLabel={option => option.tpDocumento_desc}
                            value={file.props.documentType}
                            loadOptions={async () => {
                              try {
                                const res = await oikosApi.get('/', {
                                  action: 'get',
                                  table: 'tpDocumento',
                                })

                                if (!file.props.documentType) {
                                  file.props.documentType = res.data.find(i => i.tpDocumento_id === file.props.tpDocumento_id)
                                  this.setState({ files })
                                }
                                return res.data.filter(i => i.tpDocumento_desc !== 'RG'
                                  && i.tpDocumento_desc !== 'CPF'
                                  && i.tpDocumento_desc !== 'CTPS')
                              } catch (e) {
                                return console.tron.log(e)
                              }
                            }}
                            onChange={e => {
                              file.props.documentType = e || null
                              this.setState({ files })
                              if (this.props.onFilesChange) this.props.onFilesChange([...files])
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Descrição
                          </Label>

                          <Input
                            value={file.props.description}
                            onChange={e => {
                              file.props.description = e?.target?.value || null
                              this.setState({ files })
                              if (this.props.onFilesChange) this.props.onFilesChange([...files])
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                  </div>

                  <div className="d-flex justify-content-end">
                    <Button
                      color="light"
                      size="sm"
                      title="Excluir"
                      onClick={() => this.handleDeleteFile(file.props.id)}
                    >
                      <i className="ri-delete-bin-6-line font-size-16" />
                    </Button>
                  </div>
                </Row>

                {((!this.props.multiple && files?.length <= 0) || this.props.multiple) && (
                  <Row>
                    <Col>
                      <hr />
                    </Col>
                  </Row>
                )}
              </div>
            ))}
          </>
        )}

        {((!this.props.multiple && files?.length <= 0) || this.props.multiple) && (
          <Row>
            <Col>
              <Dropzone
                accept={this.props.accept || undefined}
                multiple={this.props.multiple}
                maxFiles={this.props.maxFiles || 100}
                minSize={1}
                maxSize={100000000}
                onDrop={(files) => this.handleOnDropFiles(files)}
              >
                {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, isFocused }) => {
                  const style = {
                    ...baseStyle,
                    ...(isDragActive ? activeStyle : {}),
                    ...(isDragAccept ? acceptStyle : {}),
                    ...(isDragReject ? rejectStyle : {}),
                    ...(isFocused ? focusStyle : {}),
                  }

                  return (
                    <div {...getRootProps({ style })} className="files-dropzone">
                      <input {...getInputProps()} />
                      <Row>
                        <Col>
                          <i
                            className="ri-upload-cloud-2-line mb-3"
                            style={{
                              fontSize: 42,
                              color: '#4aa3ff',
                              opacity: 0.8,
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <h6>
                            Arraste e solte ou clique para buscar
                          </h6>
                        </Col>
                      </Row>
                      {this.props.accept && (
                        <Row>
                          <Col>
                            <span>
                              {'Extensões permitidas: '}
                              {this.props.accept.map((f, i) => {
                                if (i + 1 === this.props.accept.length) return f
                                return `${f}, `
                              })}
                            </span>
                          </Col>
                        </Row>
                      )}

                    </div>
                  )
                }}
              </Dropzone>
            </Col>
          </Row>
        )}
      </>
    )
  }
}

const baseStyle = {
  cursor: 'pointer',
  padding: '15px 16px 22px 16px',
  borderWidth: 2,
  borderRadius: 6,
  borderColor: '#ccc',
  borderStyle: 'dashed',
  backgroundColor: '#f8f8f8',
  outline: 'none',
  transition: 'all .24s ease-in-out',
  textAlign: 'center',
}

const activeStyle = {
  borderColor: '#4aa3ff',
  color: '#4aa3ff',
}

const focusStyle = {}

const acceptStyle = {
  borderColor: 'green',
  color: 'green',
}

const rejectStyle = {
  borderColor: 'red',
  color: 'red',
}
